import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = { class: "el-sidebar el-background__secondary" }
const _hoisted_2 = { class: "el-sidebar-menu" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "el-sidebar-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_4 = { class: "el-sidebar-menu" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { style: {"color":"white","text-align":"center","max-width":"min-content"} }, " Enviroment dev ", -1)
const _hoisted_6 = { class: "el-sidebar-logo" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", { class: "el-text__white el-uppercase" }, "Matrix", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", { class: "el-text__warning el-uppercase" }, "Direct Sell", -1)
const _hoisted_10 = { class: "menu-list" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "el-uppercase el-text__info" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Dashboards")
], -1)
const _hoisted_12 = { class: "el-capitalize el-text__white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({
        'el-sidebar__collapsed': true,
        'el-background__primary': true,
        hidden : _ctx.isSidebarVisible
      })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "Dashboards",
          placement: "right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass({
              'el-sidebar-menu__icon': true,
              'is-active': _ctx.$route.name === 'ListDashboards' || _ctx.$route.name === 'ViewDashboard',
              'el-text__info': true
            }),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "chart-line" })
            ], 2)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "Favorites",
          placement: "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/favorites",
              class: "el-sidebar-menu__icon el-text__info",
              "active-class": "is-active"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "star" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "Help",
          placement: "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/help",
              class: "el-sidebar-menu__icon el-text__info",
              "active-class": "is-active"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "question-circle" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.hasUrlValue)
          ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              effect: "dark",
              content: "Applications",
              placement: "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: "/applications",
                  class: "el-sidebar-menu__icon el-text__info",
                  "active-class": "is-active"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_avatar, { size: "medium" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.username.split(" ").map((n)=>n[0]).join(" ")), 1)
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass({ 'el-sidebar__expanded': true, hidden : _ctx.isMenuVisible })
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_row, {
          justify: "space-between",
          align: "middle"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 18 }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8,
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "large",
                  onClick: _ctx.toggleMenu
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "angle-double-left",
                      class: "el-text__white"
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_link, {
          type: "info",
          href: "/dashboards"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views, (view, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_component_el_link, {
              href: `/dashboards/${view.view_name}`,
              onClick: _ctx.toggleMenu
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(view.display_props.name), 1)
              ]),
              _: 2
            }, 1032, ["href", "onClick"])
          ]))
        }), 128))
      ])
    ], 2)
  ]))
}